import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem } from 'relayout'
import classnames from 'classnames'

import { getSummaryDate, getSummaryTime } from 'utils/datetime'
import { formatPriceDecimals } from 'utils/format'

import styles from './setupform-summary.css'

const SetupformSummary = ({ setupform, instances, venue }) => (
  <div styleName="setupform-summary">
    <h1 styleName="title">Review your event</h1>
    <Relayout>
      <RelayoutItem sm="6">
        <div>
          <h2 styleName="label">Event name</h2>
          <p styleName="venue">{setupform.name}</p>
        </div>
      </RelayoutItem>
      <RelayoutItem sm="6">
        <div>
          <h2 styleName="label">Venue</h2>
          <p styleName="venue">
            {venue.name}
          </p>
          <p styleName="address">
            {venue.address1}
            {venue.address2}
            {venue.city}
            {venue.postal_code}
          </p>
        </div>
      </RelayoutItem>
    </Relayout>
    <table styleName="table">
      <thead>
        <tr>
          <th styleName="label">Dates</th>
          <th styleName="label">Time</th>
          <th styleName="label">Ticket Type</th>
          <th styleName="label">QTY.</th>
          <th styleName="label">Inc.</th>
          <th styleName="label">Price</th>
        </tr>
      </thead>
      <tbody styleName="table-body">
        {instances.map((instance, i) => (
          <tr key={instance.id} styleName={classnames('row', { 'row-alternate': i % 2 !== 0 })}>
            <td styleName="first-cell">{getSummaryDate(instance.startTime)}</td>
            <td styleName="cell">{getSummaryTime(instance.startTime)}</td>
            <td styleName="cell">{instance.ticketType}</td>
            <td styleName="cell">{instance.ticketCount}</td>
            <td styleName="cell">{instance.ticketIncrement}</td>
            <td styleName="cell">
              {instance.initialPrice !== instance.discountPrice &&
                <span>
                  <strike styleName="initial-price">
                    {formatPriceDecimals(instance.initialPrice, setupform.currencyCode)}
                  </strike>/
                </span>
              }
              {formatPriceDecimals(instance.discountPrice, setupform.currencyCode)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    <h2 styleName="label">Redeem Instructions</h2>
    <p styleName="instructions">{setupform.redeemInstructions}</p>
  </div>
)

SetupformSummary.propTypes = {
  setupform: PropTypes.object,
  instances: PropTypes.array,
  venue: PropTypes.object,
}

export default CSSModules(SetupformSummary, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/setupform-summary/setupform-summary.js
 **/